const n = (o) => ({
  accordion: {
    padding: 0
  },
  accordionItem: {
    boxShadow: "none"
  },
  accordionSummary: {
    padding: 0,
    gap: 21,
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: 72,
    "&.Mui-expanded": {
      minHeight: 72
    },
    "& .MuiAccordionSummary-content": {
      flexGrow: 0,
      margin: 0,
      "&.Mui-expanded": {
        margin: 0
      }
    }
  },
  title: {
    ...o.typography.button,
    color: o.palette.common.blue400
  },
  accordionDetail: {
    position: "relative",
    color: o.palette.common.grey400,
    fontSize: o.typography.fontSize16,
    lineHeight: 1.5,
    padding: 0
  },
  expandIcon: {
    color: o.palette.common.grey500
  }
}), e = n;
export {
  e as default
};
